import type { ShouldRevalidateFunction } from 'react-router';

// Any address under the planner's layout, not the landing.
const STAY_PLANNER_PATH = /^\/travel-tools\/local-guide\/./;

// Moving between the planner's panels changes nothing the server loads: every Stay address shares
// one page type, flag, translations and page context. Skipping the reload keeps each step, and Back,
// as quick as the conversation answering instead of a server round trip.
export const staySkipsRevalidation: ShouldRevalidateFunction = ({
  currentUrl,
  defaultShouldRevalidate,
  nextUrl,
}) =>
  STAY_PLANNER_PATH.test(currentUrl.pathname) && STAY_PLANNER_PATH.test(nextUrl.pathname)
    ? false
    : defaultShouldRevalidate;
